import styled from '@emotion/styled';

import {
	IDropdownItem,
	ISelectProps,
	ITheme,
	Select,
	StyledDropdownList,
	StyledSelectMain,
} from '../../../ui';

interface ISelectInputProps extends ISelectProps {
	items: IDropdownItem[];
	initialSelectedItem?: IDropdownItem;
	placeholder?: string;
	onClick?: () => void;
	withDropdownFloatingPortal?: boolean;
}

export const SelectInput = ({
	items,
	initialSelectedItem,
	placeholder,
	onClick,
	withDropdownFloatingPortal,
	...rest
}: ISelectInputProps) => (
	<StyledSelect
		items={items}
		initialSelectedItem={initialSelectedItem}
		placeholder={placeholder}
		placeholderAsLabel
		onClick={onClick}
		withDropdownFloatingPortal={withDropdownFloatingPortal}
		{...rest}
	/>
);

const StyledSelect = styled(Select)<{}, ITheme>`
	font-weight: 400;

	${StyledDropdownList} {
		border-radius: 8px;
		margin-top: 0;
	}

	${StyledSelectMain} {
		width: max-content;
	}
`;
